var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocations = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 26,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  fillRule: "evenodd",
  d: "M8.322 0A8.32 8.32 0 0 0 0 8.322C0 12.918 8.322 26 8.322 26s8.322-13.082 8.322-17.678A8.32 8.32 0 0 0 8.322 0m0 11.967a3.797 3.797 0 1 1 0-7.594 3.797 3.797 0 0 1 0 7.594",
  clipRule: "evenodd"
})));
export default SvgLocations;